import { useQuery } from '@grandvisionhq/graphql';
import GET_SOCIAL_IDENTITY from '../operations/queries/get-social-identity.js';

const useSocialIdentity = ()=>{
    var ref;
    const { data , loading , error  } = useQuery(GET_SOCIAL_IDENTITY);
    return {
        data: data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.accountMetaData.isSocialIdentity,
        loading,
        error
    };
};

export { useSocialIdentity };
//# sourceMappingURL=use-social-identity.js.map
